import { render, staticRenderFns } from "./OutcomesDetails.vue?vue&type=template&id=50d3ce41&"
import script from "./OutcomesDetails.vue?vue&type=script&lang=js&"
export * from "./OutcomesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports